export default __webpack_public_path__ + "static/media/metabox-block-thumbnail-dark.65a8ae5a.svg";